module.exports = __webpack_public_path__ + "img/Allgemein.15c502d8.png";